var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-phone',{staticClass:"mt-3",attrs:{"new-user":"","form-message":"Введите номер телефона и выберите пароль","form-elua-warning":_vm.isIOS},on:{"done":_vm.onDone}})}
var staticRenderFns = []

export { render, staticRenderFns }